'use client';
import { YMMForm } from '@/components/molecules/YMM';
import { StyledContainer } from '@/ui-components/atoms/Layout/StyledContainer/StyledContainer';
import { Text } from '@/ui-components/atoms/Text/Text';
import { useVehiclePlatformSync } from '@/hooks/useVehiclePlatformSync';

export default function VehicleFeaturesClient() {
    const { ymmData, syncVehiclePlatform } = useVehiclePlatformSync();

    return (
        <>
            <StyledContainer paddingBottom={24}>
                <YMMForm theme="evenly-spaced" onCarReady={syncVehiclePlatform} reset={true} />
            </StyledContainer>
            {ymmData.year && ymmData.make && (
                <Text tag="span" variant="h5" dataCy="contentful-asset-group-vehicle-features-ymm-text">
                    {ymmData.year} {ymmData.make} {ymmData.model}
                </Text>
            )}
        </>
    );
}
